import { track } from "jiffy-analytics";
import ModalClass from "common/utils/ui/modal-class";

export default class SignInModalClass extends ModalClass {
  openModalCallback() {
    super.openModalCallback();
    track("sign_in_modal_opened");
  }
}
